import { MutableRefObject } from 'react';
import { scrollIntoView } from '@printdeal/ui-library';
// @ts-expect-error
import breakpointTokens from '@printdeal/brand/common/tokens/breakpoints.cjs';

import {
  GetBreakPointsProps, GetDiffInArraysProps,
} from './types';
import type { SectionDetailsType, HomepageSectionProps } from './types';

export const scrollToRef = (target: MutableRefObject<HTMLDivElement | null>) => {
  if (!target?.current) return;

  scrollIntoView(target.current, {
    block: 'start',
    behavior: 'smooth',
  });
};

export const getDataFromSections = (
  sections: HomepageSectionProps[] | undefined,
  sectionType: string,
  subSectionType: string,
) => {
  if (!sections) return {} as SectionDetailsType;
  const filteredSection = sections.find((section) => section.type === sectionType);

  if (!filteredSection) return {} as SectionDetailsType;
  const filteredSubSection = filteredSection.subSections?.find((subSection) => subSection.type === subSectionType);

  return filteredSubSection?.sectionDetails || {} as SectionDetailsType;
};

export const getSupplementalBanners = (
  section: HomepageSectionProps | undefined,
  subSectionType: string,
) => {
  if (!section) return {} as SectionDetailsType;
  const filteredSubSection = section.subSections?.filter((subSection) => subSection.type === subSectionType);

  return filteredSubSection?.map((item) => item.sectionDetails) || {} as SectionDetailsType[];
};

export const getSectionData = (section: HomepageSectionProps | undefined, subSectionType: string) => {
  if (!section) return {} as SectionDetailsType;
  const filteredSubSection = section.subSections?.find((subSection) => subSection.type === subSectionType);

  return filteredSubSection?.sectionDetails || {} as SectionDetailsType;
};

export const getBreakPoints: GetBreakPointsProps = (bp) => parseInt(breakpointTokens[bp as keyof typeof breakpointTokens].value.split('px')[0], 10);

export const getDiffInArrays: GetDiffInArraysProps = (arr1, arr2) => arr2.filter((item) =>
  !arr1.map((obj) => obj.itemId).includes(item.itemId));
